import * as React from 'react';
import { useCallback } from 'react';

import SecurityEventDetails from 'security-app/components/SecurityEvents/Alerts/EventDetails';
import { useGetSecurityEvent } from 'security-app/hooks/useSecurityEventsAPI';
import { Spinner } from 'components/common';
import type { SecurityEventAPIType } from 'security-app/hooks/api/securityEventsAPI.types';
import { ModalProvider } from 'common/contexts';
import AlertsModals from 'security-app/components/SecurityEvents/Alerts/AlertsModals';
import Routes from 'routing/Routes';
import EventDetailsContext from 'security-app/components/SecurityEvents/Alerts/EventDetails/EventDetailsContext';
import { isPermitted } from 'util/PermissionsMixin';
import useCurrentUser from 'hooks/useCurrentUser';
import { DefaultDetailsWrapper } from 'views/components/widgets/events/EventsList/EventDetails';

const EVENT_DETAILS_CONTEXT_VALUE = {
  hideEventDefinitionEdit: true,
  hideNotesEdit: true,
};

type Props = {
  eventId: string;
};

const EventDetails = ({ eventId }: Props) => {
  const { securityEvent, loadingSecurityEvents } = useGetSecurityEvent(eventId);

  const onReplaySearch = useCallback(() => {
    window.open(Routes.ALERTS.replay_search(securityEvent.event.id), '_blank');
  }, [securityEvent?.event.id]);

  if (loadingSecurityEvents || !securityEvent) {
    return <Spinner />;
  }

  return (
    <ModalProvider<any, SecurityEventAPIType>>
      <EventDetailsContext.Provider value={EVENT_DETAILS_CONTEXT_VALUE}>
        <AlertsModals />
        <SecurityEventDetails
          orientation="vert"
          securityEventId={securityEvent.event_id}
          onReplaySearch={onReplaySearch}
        />
      </EventDetailsContext.Provider>
    </ModalProvider>
  );
};

const EventDetailsWrapper = ({ eventId }: Props) => {
  const currentUser = useCurrentUser();

  if (!isPermitted(currentUser.permissions, ['graylog_security:read'])) {
    return <DefaultDetailsWrapper eventId={eventId} />;
  }

  return <EventDetails eventId={eventId} />;
};

export default EventDetailsWrapper;
